
// vue
import { defineComponent, PropType, reactive } from 'vue';

export default defineComponent({
  props: {
    number: {
      type: String,
      require: false,
      default: null,
    },
    widthType: {
      type: String as PropType<'full' | 'half'>,
      require: false,
      default: 'full',
    },
    inner: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const className = reactive<string[]>([]);

    if (props.widthType === 'half') {
      className.push('half');
    }

    if (props.number) {
      className.push('show-num');
      className.push(`num${props.number}`);
    }

    if (!props.inner) {
      className.push('p0');
    }

    return {
      className,
    };
  },
});
